import { render, staticRenderFns } from "./ConsultaObras.vue?vue&type=template&id=74b35957"
import script from "./ConsultaObras.vue?vue&type=script&lang=js"
export * from "./ConsultaObras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports